import {RbAdBannerEmergedFooterBlock} from "./rbadbanner-emergedfooter/lib/RbAdBannerEmergedFooterBlock";
import {RbAdBannerFeedListBlock} from "./rbadbanner-feedlist/lib/RbAdBannerFeedListBlock";
import {RbAdBannerFullScreenBlock} from "./rbadbanner-fullscreen/lib/RbAdBannerFullScreenBlock";

export const tags = {
    "rbadbanner-emergedfooter": RbAdBannerEmergedFooterBlock,
    "rbadbanner-feedlist": RbAdBannerFeedListBlock,
    "rbadbanner-fullscreen": RbAdBannerFullScreenBlock
};

export const lazyChunks = {
//    "rbadbanner-fullscreen": somehowImportedChunksModule
};
